// extracted by mini-css-extract-plugin
export default {"container":"DK-z","dimension":"EK-z","dimensionLabels":"FK-z"};